<template>
  <div class="purchase-view">
    <div id="auth-view-background" class="secondary lighten-1" style="position:absolute;height:100%;width:100%"></div>
    <v-container fluid>
      <v-row>
        <v-col align="center">
          <v-row align="center" justify="center">
            <v-card v-if="state === 'loading'" class="text-center">
              <v-progress-circular indeterminate color="primary"></v-progress-circular>
            </v-card>
            <v-card v-if="state === 'showthanks'" class="text-justify" width="480">
              <v-card-title>
                <p class="headline text--primary">
                  <v-icon class="ma-3" large color="green">check_circle</v-icon>Buchung erfolgreich!
                </p>
              </v-card-title>
              <v-card-text>
                <p>
                  <strong>Vielen Dank!</strong> Ihre Buchung des Abos <strong>{{ product.name }}</strong> war
                  erfolgreich. Sie können die SODA App ab sofort in diesem Tarif nutzen.
                </p>
                <p>
                  Bitte beachten Sie: <em>Die Abrechnung erfolgt über <strong>Digistore24</strong></em
                  >. Die nächste Zahlungsperiode beginnt am {{ subscription_period_end | moment("DD.MM.YYYY") }}. Das
                  Abonnement wird automatisch verlängert.
                </p>
              </v-card-text>
              <v-card-actions>
                <v-btn block outlined color="primary" v-on:click="to_app()">Weiter zur App</v-btn>
              </v-card-actions>
            </v-card>
            <v-card v-if="state === 'purchase'" class="text-justify" width="480">
              <!-- free plan to paid plan. Only combo that is supported -->
              <v-card-title>
                <p class="headline text--primary">
                  <v-icon class="ma-3" large color="blue">exit_to_app</v-icon>SODA Abo Buchung
                </p>
              </v-card-title>
              <v-card-text>
                <p>Vielen Dank, dass Sie unser Produkt nutzen möchten!</p>
                <p>
                  Sie sind in Ihrem SODA Konto mit der Email
                  <strong>{{ user_info.attributes.email }}</strong> eingeloggt. Ihr aktuell gebuchtes Abo ist
                  <strong>{{ this.current_product.name }}</strong>
                  und Sie möchten das Abo
                  <strong>{{ this.target_product.name }}</strong>
                  buchen.
                </p>
                <p>
                  Der Kauf wird über unseren Zahlungsdienstleister <strong>Digistore24</strong> abgewickelt. Zum Kauf
                  werden Sie zu der Website von <strong>Digistore24</strong> weitergeleitet. Nach erfolgtem Kauf wird
                  ihr Konto automatisch auf das Abo <strong>{{ this.target_product.name }}</strong> hochgestuft.
                </p>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn outlined color="primary" v-on:click="to_digistore()">Weiter zu Digistore24</v-btn>
              </v-card-actions>
            </v-card>
            <v-card v-if="state === 'same_product'" class="text-justify" width="480">
              <!-- paid plan to free plan. User needs to cancel subscription via payment provider. we then handle refund manually. -->
              <v-card-title>
                <p class="headline text--primary"><v-icon class="ma-3" large color="yellow">warning</v-icon>Hinweis</p>
              </v-card-title>
              <v-card-text>
                <p>
                  Sie wollen in das Abonnement <b>{{ target_product.name }}</b> buchen, das sie bereits gebucht haben.
                  Ein SODA Abo kann pro Konto nur ein Mal gebucht werden.
                </p>
              </v-card-text>
              <v-card-actions>
                <v-btn outlined color="grey" v-on:click="to_plans_menu()">zur Produktübersicht</v-btn>
                <v-spacer></v-spacer>
                <v-btn outlined color="primary" v-on:click="to_app()">zur App</v-btn>
              </v-card-actions>
            </v-card>
            <v-card v-if="state === 'rebook_to_paid'" class="text-justify" width="540">
              <!-- paid plan to other paid plan. User needs to cancel existing subscription via payment provider first, 
              then she can purchase other plan. we then handle refund manually. -->
              <v-card-title>
                <p class="headline text--primary">
                  <v-icon class="ma-3" large color="yellow">warning</v-icon>Hinweis zur Umbuchung
                </p>
              </v-card-title>
              <v-card-text>
                <p>
                  Sie haben zurzeit das Abo <strong>{{ current_product.name }}</strong> gebucht und wollen in das Abo
                  <strong>{{ target_product.name }}</strong> wechseln. Automatische Umbuchungen
                  <em>vor Ablauf der vertraglich vereinbarten Laufzeit</em> über die SODA App werden derzeit leider
                  nicht unterstützt. Wenn Sie trotzdem eine solche Umbuchung wünschen,
                  <a
                    :href="
                      'mailto:support@apjsoft.de?subject=Umbuchung%20von%20' +
                        current_product.name +
                        '%20zu%20' +
                        target_product.name
                    "
                    >kontaktieren Sie bitte unseren Support</a
                  >.
                </p>
                <p>
                  Ansonsten verwenden Sie zur Kündigung ihres aktuellen Abonnements bitte das Portal von
                  <strong>digistore24</strong>. Einen entsprechenden Link finden Sie in der Bestätigungs-Email, die Sie
                  bei der Bestellung des Produktes erhalten haben. Wenn Sie dort Ihr aktuelles Abonnement gekündigt
                  haben, wechselt SODA nach Ablauf der bezahlten Periode automatisch wieder in das Abonnement
                  <strong>SODA Free</strong>. Anschließend können Sie hier eine neue Buchung in den gewünschten Tarif
                  vornehmen.
                </p>
              </v-card-text>
              <v-card-actions>
                <v-btn outlined color="grey" v-on:click="to_plans_menu()">zur Produktübersicht</v-btn>
                <v-spacer></v-spacer>
                <v-btn outlined color="primary" v-on:click="to_app()">zur App</v-btn>
              </v-card-actions>
            </v-card>
            <v-card v-if="state === 'downgrade_to_free'" class="text-center" width="480">
              <!-- paid plan to other paid plan. User needs to cancel existing subscription via payment provider first, 
              then she can purchase other plan. we then handle refund manually. -->
              <v-card-title>
                <p class="headline text--primary">
                  <v-icon class="ma-3" large color="yellow">warning</v-icon>Hinweis zur Umbuchung
                </p>
              </v-card-title>
              <v-card-text>
                <p>
                  Sie haben zurzeit das Abo <strong>{{ current_product.name }}</strong> gebucht und wollen in das
                  kostenfreie Abo <strong>{{ target_product.name }}</strong> wechseln. Automatische Umbuchungen
                  <em>vor Ablauf der vertraglich vereinbarten Laufzeit</em> über die SODA App werden derzeit leider
                  nicht unterstützt. Wenn Sie trotzdem eine solche Umbuchung wünschen,
                  <a
                    :href="
                      'mailto:support@apjsoft.de?subject=Umbuchung%20von%20' +
                        current_product.name +
                        '%20zu%20' +
                        target_product.name
                    "
                    >kontaktieren Sie bitte unseren Support</a
                  >.
                </p>
                <p>
                  Ansonsten verwenden Sie zur Kündigung ihres aktuellen Abonnements bitte das Portal von
                  <strong>digistore24</strong>. Einen entsprechenden Link finden Sie in der Bestätigungs-Email, die Sie
                  bei der Bestellung des Produktes erhalten haben. Wenn Sie dort Ihr aktuelles Abonnement gekündigt
                  haben, wechselt SODA nach Ablauf der bezahlten Periode automatisch wieder in das Abonnement
                  <strong>SODA Free</strong>.
                </p>
              </v-card-text>
              <v-card-actions>
                <v-btn outlined color="grey" v-on:click="to_plans_menu()">zur Produktübersicht</v-btn>
                <v-spacer></v-spacer>
                <v-btn outlined color="primary" v-on:click="to_app()">zur App</v-btn>
              </v-card-actions>
            </v-card>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
/*
This View is loaded when user selects one of the plans in the PlanMenuView
*/

const plans_specs = require("json-loader!yaml-loader!../specs/plans.yml");
function arrayToObject(arr, key) {
  var rv = {};
  for (var i = 0; i < arr.length; ++i) rv[arr[i][key]] = arr[i];
  return rv;
}
const products = arrayToObject(plans_specs.products, "id");

export default {
  name: "PurchaseView",
  computed: {
    user_info() {
      return this.$store.state.originalStore.user_info;
    },
    is_prod_env() {
      var host = window.location.host;
      if (host === "app.soda-dsgvo.de") {
        return true;
      }
      return false;
    },
    active_product_id() {
      return this.$store.state.originalStore.user_info
        ? this.$store.state.originalStore.user_info.attributes["custom:active_product_id"]
        : null;
    },
  },
  async mounted() {
    // we can get here from the purchase menu only
    //console.log('PurchaseView.mounted()', this.user_info.attributes)

    var user_info = await this.$Amplify.Auth.currentUserInfo();
    var cognito_user = await this.$Amplify.Auth.currentAuthenticatedUser({ bypassCache: true });
    var current_product_id = user_info.attributes["custom:active_product_id"];

    if (this.$route.query.finished === "true") {
      // we got here from a redirect from digistore24 because the update was successful.
      // did update plan successfully. we can delete the payment intent from local storage and show the thank you message
      // but first verify update was successful
      this.subscription_period_end = user_info.attributes["custom:d24_valid_to_ts"];
      this.product = products[current_product_id];
      this.state = "showthanks";
      this.clear_payment_intent();
      return;
    }

    var intent_product_id = localStorage.getItem("payment_intent_product_id");
    if (intent_product_id === null) {
      // it was wrong to come here in the first place. forward to app.
      this.to_app();
      return;
    }
    this.target_product = products[intent_product_id];

    if (!current_product_id && !this.target_product.paid) {
      // new plan && plan is free -> skip payment and forward to app.
      var cognito_user = this.$Amplify.Auth.currentAuthenticatedUser();
      this.$Amplify.Auth.updateUserAttributes(cognito_user, {
        "custom:active_product_id": intent_product_id,
      })
        .then((res) => {
          this.$router.push({ path: "/app/account" });
        })
        .catch((err) => {
          console.error("error updating cognito user attribute", err);
        });
      return;
    }

    current_product_id = current_product_id || "soda-free-v1";
    this.current_product = products[current_product_id];

    if (this.target_product === this.current_product) {
      this.state = "same_product";
      return;
    }

    if (this.current_product.paid && this.target_product.free) {
      this.state = "downgrade_to_free";
      return;
    }

    if (this.current_product.paid && this.target_product.paid) {
      this.state = "rebook_to_paid";
      return;
    }

    // this.current_product.free && this.target_product.paid is the only configuration that our flow supports.
    // it is also the most relevant one.

    var plan_env = this.is_prod_env ? "prod" : "test";
    this.ds24_product_id = plans_specs.digistore24_ids[plan_env].products[this.target_product.id];

    this.state = "purchase";
  },
  methods: {
    to_app() {
      this.$router.push({ path: "/app/account" });
    },
    to_plans_menu() {
      this.$router.push({ path: "/home/plans" });
    },
    to_digistore() {
      //var ds24_product_id = localStorage.getItem('payment_intent_ds24_product_id')
      var url = `https://www.digistore24.com/product/${this.ds24_product_id}/?custom=${this.user_info.username}`;
      window.location.replace(url);
    },
    clear_payment_intent() {
      localStorage.removeItem("payment_intent_product_id");
    },
  },
  data: function() {
    return {
      user_id: null,
      state: "loading",
      customer: null,
      subscription: null,
      process_purchase_intent: false,
      will_redirect_to_payment_provider: false,
      products: arrayToObject(plans_specs.products, "id"),
      current_product: null,
      target_product: null,
      ds24_product_id: null,
      subscription_period_end: null,
    };
  },
};
</script>

<style lang="stylus" scoped></style>
